import {translations as defaultTranslation} from '../i18n'

export const translations = {
    fr: {
        errorTypeEnum: {
            onlyOneClaimOpenedByTicket: 'Une réclamation existe déjà pour ce ticket'
        },
        openedDateTimeFormat: '[Ouvert] ' + defaultTranslation.fr.dateFormat.default + ' ' + defaultTranslation.fr.timeFormat.long,
        searchStream: {
            xs: 'rechercher',
            sm: 'rechercher dans les réclamations'
        },
        stateEnum: {
        	opened: 'ouvert',
            qualified: 'qualifié',
            answered: 'réponse à la réclamation',
            challenged: 'contesté',
            challengeAnswered: 'réponse à la contestation'
        },
        assignedEntity: 'porteur de l\'action corrective',
        accountableEntity: 'organisme responsable',
        entityEnum: {
            callCenter: 'Centre d\'appel',
            clientAccount: 'Client',
            none: 'Autre'
        },
        ticket: 'ticket',
        claims: 'réclamations',
        ticketClaim: 'réclamation',
        ticketClaims: 'réclamations',
        ticketClaimNotProcessed: 'la réclamation n\'est pas encore traitée',
        newTicketClaim: 'nouvelle réclamation',
        openTicketClaim: 'ouvrir la réclamation',
        qualifyTicketClaim: 'qualifier la réclamation',
        answerTicketClaim: 'répondre à la réclamation',
        challengeTicketClaim: 'contester la réclamation',
        answerChallengeTicketClaim: 'répondre à la contestation',
        ticketClaimCategory: 'typologie de réclamation',
        failureCause: 'cause de défaillance identifiée',
        postAnalysis: 'analyse',
        ticketClaimAnswer: 'réponse à la réclamation',
        callerIdentity: 'identification appelant',
        interventionLocation: 'lieu d\'intervention',
        interventionMonitoring: 'suivi d\'intervention',
        ticketReference: 'référence du ticket',
        urgencyLevel: 'priorité de traitement',
        category: 'catégorie',
        treatmentPriority: 'priorité',
        severity: 'sévérité',
        qualification: 'qualification',
        challenge: 'contestation',
        challengeAnswer: 'réponse à la contestation',
        agency: 'portefeuille',
        selectAgency: 'portefeuille',
        externalClientName: 'Nom du client final',
        externalPatrimonyReference: 'Lot ou installation concerné(e)',
        externalCallDate: 'Date et heure d\'appel du client'
    }
}

export default {...defaultTranslation.fr, ...translations.fr}


// WEBPACK FOOTER //
// ./lib/claim/i18n.js